import { FILTERS } from './evidenceFilters';

export const RYCZALT_PURCHASES_LISTING_FILTERS = {
  path: '/evidences/ryczalt-purchases',
  filters: FILTERS,
};
